window.GetPoint=function()
{
 return  2+2;

};
var xxx=10;